import { Box, keyframes } from '@mui/material';
import type { SxProps } from '@mui/material';

type RingProps = {
    ringSize: number;
    dotSize: number;
    offset?: number;
    dotCount?: number;
    animation?: string;
};

const innerRingSize = 67.5;

const rotateKeyframes = keyframes`
  0% {
    transform: rotate(0deg)
  }
  75% {
    transform: rotate(360deg)
  }
  100% {
    transform: rotate(360deg)
  }
`;
const rotateOffsetKeyframes = keyframes`
  0% {
    transform: rotate(0deg)
  }
  75% {
    transform: rotate(${360 - 180 / 13}deg)
  }
  100% {
    transform: rotate(${360}deg)
  }
`;

const shrink = keyframes`
  0% {
  }
  10% {
  }
  75% {
    top: ${50 - innerRingSize / 2}%;
    left: ${50 - innerRingSize / 2}%;
    width: ${innerRingSize}%;
    height: ${innerRingSize}%;
  }
  // 75% {
  //   top: ${50 - innerRingSize / 2}%;
  //   left: ${50 - innerRingSize / 2}%;
  //   width: ${innerRingSize}%;
  //   height: ${innerRingSize}%;
  // }
  75% {
  }
`;

const Ring = ({
    dotSize,
    ringSize,
    dotCount = 13,
    offset = 0,
    animation,
}: RingProps) => {
    const range = [...Array(dotCount).keys()];
    return (
        <Box
            sx={(theme) => ({
                top: `${50 - ringSize / 2}%`,
                left: `${50 - ringSize / 2}%`,
                width: `${ringSize}%`,
                height: `${ringSize}%`,
                position: 'absolute',
                animation: animation,
                '& div': {
                    width: `${dotSize}%`,
                    height: '100%',
                    left: `${50 - dotSize / 2}%`, // hmm
                    //left: '48%',
                    position: 'absolute',
                },
                '& div:after': {
                    content: '""',
                    width: '100%',
                    height: `${dotSize}%`,
                    background: theme.palette.primary.main,
                    borderRadius: '50%',
                    position: 'absolute',
                },
                ...range.reduce(
                    (sx, n) => ({
                        ...sx,
                        [`& > div:nth-of-type(${n + 1})`]: {
                            transform: `translate(0, 0) rotate(${
                                360 * ((n + offset) / range.length)
                            }deg)`,
                        },
                    }),
                    {},
                ),
            })}
        >
            {range.map((n) => (
                <div key={n} />
            ))}
        </Box>
    );
};
type CssSymbolProps = {
    size?: number;
    animated?: boolean;
    sx?: SxProps;
};
export const CssSymbol = (props: CssSymbolProps) => {
    const { size = 48, animated = false, sx } = props;
    return (
        <Box width={size} height={size} position="relative" sx={sx}>
            <Ring
                ringSize={100}
                dotSize={3}
                offset={1}
                animation={
                    animated
                        ? `${rotateKeyframes} 2s ease-in-out infinite, ${shrink} 2s ease-in-out infinite`
                        : undefined
                }
            />
            <Ring
                ringSize={86}
                dotSize={7}
                offset={0.5}
                animation={
                    animated
                        ? `${rotateOffsetKeyframes} 2s ease-in-out infinite, ${shrink} 2s ease-in-out infinite`
                        : undefined
                }
            />
            <Ring
                ringSize={innerRingSize}
                dotSize={14}
                animation={
                    animated
                        ? `${rotateKeyframes} 2s ease-in-out infinite, ${shrink} 2s ease-in-out infinite`
                        : undefined
                }
            />
        </Box>
    );
};
